import { GET_EMPLOYEE_DATA, GET_INITIAL_SHIFT_PROFILE } from "./redux.actionTypes";


export const getEmployeeData = ({ handleSubmit, payload }) => ({
    type: GET_EMPLOYEE_DATA,
    meta: { handleSubmit },
    payload,
});

export const getInitialShift = ({ handleSubmit, payload }) => ({
    type: GET_INITIAL_SHIFT_PROFILE,
    meta: { handleSubmit },
    payload,
});